import { useEffect } from 'react';
import { emit } from '@zapier/events-toolkit-browser';
import isEmpty from 'lodash/isEmpty';
import { urls } from '@zapier/identity-utils';
import { captureException } from '@sentry/react';
import { Modal, ModalBody, ModalFooter } from '../Modal';
import { Button, Link } from '@zapier/marketing-ui';

type Props = {
  errorMessage?: string;
  onClickOk: () => void;
};

export const DEFAULT_DOMAIN_CAPTURE_ERROR_MODAL_MESSAGE =
  'Something went wrong.';

export function DomainCaptureErrorModal({ errorMessage, onClickOk }: Props) {
  useEffect(() => {
    try {
      void emit(
        {
          system_name: 'identity',
          modal_flag: true,
          modal_name: 'DomainCaptureErrorModal',
          modal_view_name: 'Domain Capture error',
        },
        'web_analytics.tracking.page_view.PageViewEvent'
      );
    } catch (err) {
      captureException(err, {
        tags: {
          section: 'DomainCaptureErrorModal',
          type: 'PageViewEvent',
        },
      });
    }
  }, []);

  if (isEmpty(errorMessage)) {
    errorMessage = DEFAULT_DOMAIN_CAPTURE_ERROR_MODAL_MESSAGE;
  }

  return (
    <Modal title="An error occurred" onClose={onClickOk}>
      <ModalBody>
        <p>{errorMessage}</p>
        <p>
          If you encounter this error repeatedly,{' '}
          <Link href={urls.HELP_URL} target="_blank">
            contact Support
          </Link>
          .
        </p>
      </ModalBody>
      <ModalFooter>
        <Button variant="secondary" size="small" onClick={onClickOk}>
          Close and try again
        </Button>
      </ModalFooter>
    </Modal>
  );
}
